export const CHATBOT_ID = 'clkv7a1010057mp21vn81zt7t';
